<div class="container">
    <div class="mt-4" *ngIf="roles.length > 1">
        <h4 class="modal-title text-secondary" id="modal-basic-title">
            <strong class="text-secondary">Seleccione el rol con el que desea ingresar.</strong>
        </h4>
    </div>
    <br>
    <div class="modal-body gap-3 d-flex flex-row justify-content-center">
        <div class="card card-pointer border border-primary border-5 col-md-3 text-center" *ngFor="let rol of roles">
            <div class="card-body">
                <h5 class="card-title fw-bold">{{rol.vcCodigoInterno.split('_')[1]}}</h5>
                <br>
                <button class="btn btn-secondary mb-4" (click)="redirectUser(rol.vcCodigoInterno, rol.id)">ACEPTAR</button>
            </div>
        </div>
    </div>
</div>